import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    SingleIndexResponse, IndicesQuotesData, IndicesFilterParams,
    IndicesFilterResponse, AddIndicesParams
} from '../../../../../app.interfaces';
import { applicationUrls } from 'sharedweb/helpers/urls';

@Injectable({
    providedIn: 'root'
})
export class IndicesService {

    constructor(private _httpClient: HttpClient) { }

    getUserIndices() {
        const url = applicationUrls.getUserIndices;
        return this._httpClient.get<SingleIndexResponse[]>(url);
    }

    addIndex(addIndexParams: AddIndicesParams) {
        const url = applicationUrls.getUserIndices;
        return this._httpClient.post<SingleIndexResponse>(url, addIndexParams);
    }

    removeIndex(indexId: number) {
        const url = `${applicationUrls.getUserIndices}${indexId}/`;
        return this._httpClient.delete(url);
    }

    getIndicesQuotes() {
        const url = `${applicationUrls.getUserIndices}quote/`;
        return this._httpClient.get<IndicesQuotesData>(url);
    }

    getIndicesMarkets() {
        const url = `${applicationUrls.getIndicesStaticList}markets/`;
        return this._httpClient.get<string[]>(url);
    }

    filterIndices(indicesFilterParams: IndicesFilterParams) {
        const url = `${applicationUrls.getIndicesStaticList}filter/`;
        return this._httpClient.get<IndicesFilterResponse>(url, {
            params: <any>indicesFilterParams
        });
    }

}
